var _circle, _circle2, _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgWarningYellow = function SvgWarningYellow(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 40.5,
    fill: "#3A2F81",
    fillOpacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 41,
    r: 12,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10919_33631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5 23C45.1413 23 49.5925 24.8437 52.8744 28.1256C56.1563 31.4075 58 35.8587 58 40.5C58 45.1413 56.1563 49.5925 52.8744 52.8744C49.5925 56.1563 45.1413 58 40.5 58C35.8587 58 31.4075 56.1563 28.1256 52.8744C24.8437 49.5925 23 45.1413 23 40.5C23 35.8587 24.8437 31.4075 28.1256 28.1256C31.4075 24.8437 35.8587 23 40.5 23ZM40.5 30.5C40.1826 30.4997 39.8686 30.5657 39.5782 30.6936C39.2877 30.8215 39.0271 31.0086 38.813 31.2429C38.5989 31.4772 38.436 31.7536 38.3348 32.0545C38.2335 32.3553 38.1961 32.6739 38.225 32.99L39.1375 43.005C39.1729 43.3417 39.3317 43.6534 39.5833 43.8799C39.8349 44.1065 40.1614 44.2318 40.5 44.2318C40.8386 44.2318 41.1651 44.1065 41.4167 43.8799C41.6683 43.6534 41.8271 43.3417 41.8625 43.005L42.7725 32.99C42.8013 32.6741 42.764 32.3557 42.6629 32.0551C42.5618 31.7544 42.3992 31.4781 42.1854 31.2438C41.9716 31.0096 41.7113 30.8224 41.4211 30.6943C41.1309 30.5663 40.8172 30.5001 40.5 30.5ZM40.5 50.5C41.0304 50.5 41.5391 50.2893 41.9142 49.9142C42.2893 49.5391 42.5 49.0304 42.5 48.5C42.5 47.9696 42.2893 47.4609 41.9142 47.0858C41.5391 46.7107 41.0304 46.5 40.5 46.5C39.9696 46.5 39.4609 46.7107 39.0858 47.0858C38.7107 47.4609 38.5 47.9696 38.5 48.5C38.5 49.0304 38.7107 49.5391 39.0858 49.9142C39.4609 50.2893 39.9696 50.5 40.5 50.5Z",
    fill: "#E7852B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10919_33631",
    x: 19,
    y: 23,
    width: 43,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10919_33631"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10919_33631",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarningYellow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning-yellow.47328ed9.svg";
export { ForwardRef as ReactComponent };